import { dd } from 'framer-motion/client';
import {API_BASE_URL} from '../constant/constant';

// Development mode flag - set to true for offline testing

// Helper function to handle API responses
const handleResponse = async (response) => {
  if (!response.ok) {
    const errorData = await response.json();
    throw new Error(errorData.message || 'Something went wrong');
  }
  return response.json();
};

// Login API call
export const loginUser = async (credentials) => {
 
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(credentials),
  });

  return handleResponse(response);
};

// Signup API call
export const signupUser = async (userData) => {

  const response = await fetch(`${API_BASE_URL}/auth/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(userData),
  });

  return handleResponse(response);
};

// Forgot password API call
export const forgotPassword = async (email) => {
  const response = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ email }),
  });

  return handleResponse(response);
};

// Reset password API call
export const resetPassword = async (token, newPassword) => {
  const response = await fetch(`${API_BASE_URL}/auth/reset-password`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token, password: newPassword }),
  });

  return handleResponse(response);
};

// Get user profile API call
export const getUserProfile = async (token) => {
  const response = await fetch(`${API_BASE_URL}/auth/profile`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return handleResponse(response);
};

// Get user dashboard data API call
export const getUserDashboardData = async (token) => {
  const response = await fetch(`${API_BASE_URL}/dashboard/user-dashboard-all`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  return handleResponse(response);
};

// Update user profile API call
export const updateUserProfile = async (token, profileData) => {
  const formData = new FormData();
  
  // Add all profile fields to FormData
  Object.keys(profileData).forEach(key => {
    if (profileData[key] !== null && profileData[key] !== undefined) {
      formData.append(key, profileData[key]);
    }
  });

  const response = await fetch(`${API_BASE_URL}/users/profile`, {
    method: 'PUT',
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    body: formData,
  });

  return handleResponse(response);
};

// Change password API call
export const changePassword = async (token, passwordData) => {
  const response = await fetch(`${API_BASE_URL}/auth/change-password`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(passwordData),
  });

  return handleResponse(response);
};

// Helper functions for dummy mode
const isDemoCredentials = (credentials) => {
  const demoCredentials = [
    { email: "admin@nkenne.com", password: "admin123" },
    { email: "user@nkenne.com", password: "user123" }
  ];
  
  return demoCredentials.some(demo => 
    demo.email === credentials.email && demo.password === credentials.password
  );
};

const simulateLoginResponse = async (credentials) => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1000));
  
  const role = credentials.email === "admin@nkenne.com" ? "ADMIN" : "USER";
  
  return {
    user: {
      _id: role === "ADMIN" ? "admin123" : "user123",
      firstName: role === "ADMIN" ? "Admin" : "John",
      lastName: role === "ADMIN" ? "User" : "Doe",
      email: credentials.email,
      role: role,
      tokens: 100,
      apiKeys: [`demo-api-key-${role.toLowerCase()}`],
      purchaseHistory: [],
      profilePicture: null,
      phone: "+1234567890",
      company: role === "ADMIN" ? "Nkenne AI" : "Demo Company"
    },
    token: `dummy-token-${role.toLowerCase()}-${Date.now()}`,
    apiKey: `demo-api-key-${role.toLowerCase()}`
  };
};

const simulateSignupResponse = async (userData) => {
  // Simulate network delay
  await new Promise(resolve => setTimeout(resolve, 1500));
  
  const role = userData.email === "admin@nkenne.com" ? "ADMIN" : "USER";
  
  return {
    user: {
      _id: `demo-${role.toLowerCase()}-${Date.now()}`,
      firstName: userData.firstName,
      lastName: userData.lastName,
      email: userData.email,
      role: role,
      tokens: 100,
      apiKeys: [`demo-api-key-${role.toLowerCase()}`],
      purchaseHistory: [],
      profilePicture: null,
      phone: "+1234567890",
      company: role === "ADMIN" ? "Nkenne AI" : "Demo Company"
    },
    token: `dummy-token-${role.toLowerCase()}-${Date.now()}`,
    apiKey: `demo-api-key-${role.toLowerCase()}`
  };
};